
{
  "fr": {
    "configuratorAddCustomizationDropdownMenu": {
      "trigger": {
        "label": "Ajouter un contenu",
        "title": "@:configuratorAddCustomizationDropdownMenu.trigger.label"
      },
      "action": {
        "addText": {
          "label": "Texte",
          "title": "Ajouter un texte"
        },
        "addImage": {
          "label": "Image",
          "title": "Ajouter une image"
        }
      }
    }
  }
}
